import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ease } from '../../utils/easing';
import { media } from '../../utils/media-queries';

const Plus = ({
  triggerAnim,
  light = false,
  dark = false,
  inactive = false,
}) => {
  const duration = 0.15;

  const firstLine = {
    closed: {
      rotate: 0,
      color: `${light ? 'var(--black)' : 'var(--red)'}`,
      transition: { duration, ease: ease.outSnap },
    },
    open: {
      rotate: 90,
      color: 'var(--white)',
      transition: { duration, ease: ease.inSnap },
    },
  };

  const wrapperColor = { background: light ? '#F9F7F7' : 'var(--white)' };
  const wrapperColorActive = {
    background: dark ? 'var(--white)' : 'var(--red)',
  };
  const lineColor = { background: light ? 'var(--black)' : 'var(--red)' };
  const lineColorActive = { background: dark ? 'var(--red)' : 'var(--white)' };

  return (
    <StyledPlus className="plus" inactive={inactive}>
      <div
        className="wrapper"
        style={triggerAnim ? wrapperColorActive : wrapperColor}
      >
        <motion.div
          className="first-line"
          variants={firstLine}
          initial="closed"
          animate={triggerAnim ? 'open' : 'closed'}
          style={triggerAnim ? lineColorActive : lineColor}
        />
        <div
          className="second-line"
          style={triggerAnim ? lineColorActive : lineColor}
        />
      </div>
    </StyledPlus>
  );
};

const StyledPlus = styled.div`
  cursor: pointer;
  position: absolute;
  opacity: ${(props) => (props.inactive ? 0.4 : 1)};

  .wrapper {
    border-radius: 50%;
    height: 32px;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s;

    .first-line {
      position: absolute;
      width: 1px;
      height: 16px;
    }

    .second-line {
      position: absolute;
      width: 16px;
      height: 1px;
    }
  }
`;

Plus.propTypes = {
  light: PropTypes.bool,
  dark: PropTypes.bool,
  triggerAnim: PropTypes.bool,
};

export default Plus;
